export const STOCK_COUNT_STATUS = Object.freeze({
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  REALIZED: "REALIZED",
  APPROVED: "APPROVED",
  CANCELLED: "CANCELLED",
  EXPIRED: "EXPIRED",
});

export const STOCK_COUNT_STATUS_LABELS = Object.freeze({
  [STOCK_COUNT_STATUS.PENDING]: "Pendiente",
  [STOCK_COUNT_STATUS.IN_PROGRESS]: "En curso",
  [STOCK_COUNT_STATUS.REALIZED]: "Realizado",
  [STOCK_COUNT_STATUS.APPROVED]: "Aprobado",
  [STOCK_COUNT_STATUS.CANCELLED]: "Cancelado",
  [STOCK_COUNT_STATUS.EXPIRED]: "Vencido",
});

function asNumber(value, fallback = 0) {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
}

export function normalizeStockCount(stockCount = {}) {
  return {
    ...stockCount,
    id: asNumber(stockCount.id),
    licenseId: asNumber(stockCount.licenseId),
    status: String(stockCount.status || ""),
    counterEmployeeId: asNumber(stockCount.counterEmployeeId),
    counterNameSnapshot: String(stockCount.counterNameSnapshot || ""),
    auditorEmployeeId: asNumber(stockCount.auditorEmployeeId),
    auditorNameSnapshot: String(stockCount.auditorNameSnapshot || ""),
    deadlineAt: stockCount.deadlineAt || null,
    theoreticalStockCapturedAt: stockCount.theoreticalStockCapturedAt || null,
    counterStartedAt: stockCount.counterStartedAt || null,
    counterCompletedAt: stockCount.counterCompletedAt || null,
    auditorStartedAt: stockCount.auditorStartedAt || null,
    auditorCompletedAt: stockCount.auditorCompletedAt || null,
    approvedByUserId:
      stockCount.approvedByUserId === null ||
      stockCount.approvedByUserId === undefined
        ? null
        : asNumber(stockCount.approvedByUserId),
    approvedAt: stockCount.approvedAt || null,
    cancelledByUserId:
      stockCount.cancelledByUserId === null ||
      stockCount.cancelledByUserId === undefined
        ? null
        : asNumber(stockCount.cancelledByUserId),
    cancelledAt: stockCount.cancelledAt || null,
    createdByUserId:
      stockCount.createdByUserId === null ||
      stockCount.createdByUserId === undefined
        ? null
        : asNumber(stockCount.createdByUserId),
    createdAt: stockCount.createdAt || null,
    updatedAt: stockCount.updatedAt || null,
  };
}

export function normalizeStockCountList(response = {}) {
  return {
    data: Array.isArray(response.data)
      ? response.data.map(normalizeStockCount)
      : [],
    meta: {
      page: asNumber(response.meta?.page, 1),
      limit: asNumber(response.meta?.limit, 20),
      totalItems: asNumber(response.meta?.totalItems),
      totalPages: asNumber(response.meta?.totalPages),
      hasNextPage: Boolean(response.meta?.hasNextPage),
      hasPreviousPage: Boolean(response.meta?.hasPreviousPage),
    },
  };
}
